import React, { FunctionComponent, ReactElement } from 'react'
import Grid from '@sport1/react-elements/Grid'
import AssetImage from '../../BaseComponents/Image/Asset'
import Alert from '../../BaseComponents/Alert'
import { TestID } from '../../utils/PropTypesDefinitions'
import SmallBodyFont from '../../Theme/Fonts/SmallBody'
import BigButton from '../../BaseComponents/Button/Standard/Big'

export type PrivacyAlertProps = {
    /** background image file */
    backgroundImage?: string
    /** info about backgroundImageAlt for seo */
    backgroundImageAlt?: string
    /** text shown inside of the alert */
    text: string
    /** text used for the button inside of the alert */
    buttonText?: string
    /**
     * function called if alert button is pressed
     *
     * @TJS-type function
     * */
    onPress?: () => void
} & TestID

const PrivacyAlert: FunctionComponent<PrivacyAlertProps> = ({
    backgroundImage,
    backgroundImageAlt,
    text,
    buttonText,
    onPress,
    testID,
}): ReactElement => {
    return (
        <Grid position="relative" testID={testID} height="100%">
            {backgroundImage ? (
                <AssetImage
                    width="100%"
                    height="100%"
                    imageUrl={backgroundImage}
                    alt={backgroundImageAlt}
                />
            ) : null}
            <Grid noExpand center position="absolute" height="100%" left={36} right={36}>
                <Alert
                    text={
                        <SmallBodyFont color="WHITE" textAlign="center">
                            {text}
                        </SmallBodyFont>
                    }
                    primaryButton={
                        buttonText && onPress ? (
                            <BigButton backgroundColor="WHITE" expand onPress={onPress}>
                                {buttonText}
                            </BigButton>
                        ) : undefined
                    }
                />
            </Grid>
        </Grid>
    )
}

export default PrivacyAlert
